<div class="preview" *ngIf="isOpen">
  <div class="preview-header">
    <span class="preview-header__tittle">
      {{ damElement?.header }}
    </span> <span class="preview-header__id">
      ID {{ damElement?.id }}
    </span> <span class="preview-header__files-count">
      <nb-icon icon="attach-outline"/>

    {{ damElement?.countVersion }}{{ createLabel(damElement?.countVersion, 'вложение|вложения|вложений') }}
    </span>

    <button nbButton status="control" (click)="close()" class="close">
      <nb-icon icon="close"/>
    </button>
  </div>

  <div class="preview-section preview-images">
    <div class="preview-images-carousel">
      <button class="control-prev" status="control" nbButton *ngIf="carouselIndex > 0" type="button" (click)="carousel.prev()">
        <nb-icon icon="chevron-left-outline"/>
      </button>

      <tui-carousel #carousel [(index)]="carouselIndex">
        <ng-container *ngFor="let image of filterVersions(damItemVersions)">
          <div *tuiItem class="item">
            <app-secured-image *ngIf="damService.showThumbnail(image.mimeType)" [src]="'/dam/get-image-dynamic-version/' + image?.id"/>
            <img *ngIf="!damService.showThumbnail(image.mimeType)" style="max-width:100px" src="/assets/images/vivid/{{damService.getExtension(image)}}.svg" alt="">
            <!--            <img-->
            <!--              class="carousel-img"-->
            <!--              [src]="image?.href" alt=""-->
            <!--            >-->
          </div>
        </ng-container>
      </tui-carousel>

      <button status="control" class="control-next" nbButton *ngIf="carouselIndex < (damItemVersions?.length - 1)" type="button" (click)="carousel.next()">
        <nb-icon icon="chevron-right-outline"/>
      </button>
    </div>

    <div class="selected-img-tittle" *ngIf="damItemVersions[carouselIndex]">
      {{ damItemVersions[carouselIndex]?.header || 'no tittle' }}
    </div>

    <ng-container *ngIf="damItemVersions?.length > 1">
      <div class="preview-images-list">
        <div *ngFor="let image of filterVersions(damItemVersions); index as i" class="preview-images-list-item" (click)="setCarouselIndex(i)">
          <app-secured-image *ngIf="damService.showThumbnail(image.mimeType)" [src]="'/dam/get-image-dynamic-version/' + image?.id"/>
          <img *ngIf="!damService.showThumbnail(image.mimeType)" style="max-height:62px" src="/assets/images/vivid/{{damService.getExtension(image)}}.svg" alt="">
          <!--        <img-->
          <!--          class="preview-images-list-item__img"-->
          <!--          [ngClass]="{'active': i === carouselIndex}"-->
          <!--          src="/dam/get-image-dynamic-version/{{image.id}}" alt=""-->
          <!--        >-->
        </div>
      </div>
      <tui-pagination size="s" class="pagination" [length]="filterVersions(damItemVersions).length" [(index)]="carouselIndex"></tui-pagination>
    </ng-container>

    <div class="files-actions">

      <button nbButton size="small" [matMenuTriggerFor]="seeMore">
        <nb-icon icon="download-outline"/>
        Скачать
      </button>
      <mat-menu #seeMore="matMenu">
        <button mat-menu-item (click)="damService.downloadDamItem(damElement)">
          Скачать все
        </button>
        <button mat-menu-item (click)="downloadDamItemVersion(damElement.id, damElement.header)">
          Скачать текущий
        </button>
      </mat-menu>

      <nb-checkbox (checkedChange)="onAllFileExtensionsToggle($event)" [checked]="isAllExtensionsSelected">
        Выбрать все
      </nb-checkbox>
    </div>

    <hr>

    <div class="files">
      <span class="files__count">
        Выбрано: {{ filteredVersions }}
      </span>

      <div class="files-list">
        <ng-container *ngFor="let file of fileExtensions; index as i">
          <nb-checkbox (checkedChange)="onFileExtensionToggle(i)" [checked]="file?.selected">
            {{ file?.typeOfFile }}({{ file?.count }})
          </nb-checkbox>

        </ng-container>
      </div>
    </div>
  </div>

  <div class="preview-section">
    <div class="share-buttons">
      <button nbButton size="small" (click)="share(damElement)">
        <nb-icon icon="share-outline"/>
        Поделиться
      </button>
    </div>

    <hr>

    <div class="statuses">
      <nb-toggle [checked]="damElement.enabled" (checkedChange)="changeEnabled(damElement.id, $event)">
        Активен
      </nb-toggle>

      <nb-toggle [checked]="damElement.approved" (checkedChange)="changeApproved(damElement.id, $event)">
        Одобрен <small>{{ damElement.approvedAt | date: 'short' }} </small> <small *ngIf="damElement.approvedManagerName">{{ damElement.approvedManagerName }} </small>
      </nb-toggle>
      <nb-toggle [checked]="damElement.deleted" (checkedChange)="changeDeleted(damElement.id, $event)">
        Удален <small> {{ damElement.deletedAt | date:'short' }}</small>
      </nb-toggle>
    </div>

  </div>

  <div class="preview-section">
    <label *ngIf="damElement?.tagsForPreview?.length>0" class="form-label"> Теги </label>

    <div *ngIf="damElement?.tagsForPreview?.length>0">
      <div *ngFor="let tag of damElement?.tagsForPreview" class="badge">
        {{ tag }}
      </div>
    </div>


    <hr *ngIf="damElement?.tagsForPreview?.length>0">

    <div class="status-history">
      <div class="status-history-item">
        <span> Создан {{ damElement.createdAt | date }} </span>

        <span *ngIf="damElement.managerName">
          <nb-icon icon="person-outline"/>
          {{ damElement.managerName }}
        </span>
      </div>

      <div class="status-history-item" *ngIf="damElement.updatedAt!=null">
        <span> Изменен {{ damElement.updatedAt | date }} </span>

        <!--        <span>-->
        <!--          <img class="manager-icon" src="assets/icons/Avatar.png" alt="">-->
        <!--          Manager test text-->
        <!--        </span>-->
      </div>
    </div>
  </div>

  <a [routerLink]="['/cabinet/dam/item/edit', damElement.id]" nbButton> Подробнее </a>
</div>
